import {SwitchProps} from 'platform/components';

import featureFlags from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsStackItems, SettingsTemplate} from '@dms/settings/shared';

import {buildArray} from 'shared/web';

export interface Items {
  title: string;
  url?: string;
  cyId?: string;
  switchProps?: SwitchProps;
}

export function Interest() {
  const items = buildArray<Items>()
    .add({
      cyId: testIds.settings.interestDefinition('link'),
      title: i18n.t('entity.seriesDefinition.labels.interestCodeDefinition'),
      url: settingsRoutes.interestDefinition,
    })
    .whenFeatureEnabled(featureFlags.CORE_TEAMS, {
      cyId: testIds.settings.salesLeadsAssignment('link'),
      title: i18n.t('entity.seriesDefinition.labels.salesLeadsAssignment'),
      url: settingsRoutes.salesLeadsAssignment,
    });

  return (
    <SettingsTemplate
      header={{title: i18n.t('entity.interest.labels.interest')}}
      data-testid="integrations-business-case-settings-modal"
    >
      <SettingsStackItems items={items} />
    </SettingsTemplate>
  );
}
